import { Sparkles } from 'lucide-react'
import { toast } from '@/lib/hooks/use-toast'
import { useNewApuracao } from '../../services/useNewApuracao'
import { TypeViewProduct } from '../../state/selectProduct'
import ButtonConfirmAction from '@/components/ui/button-confirm-atcion'

interface Props {
  id_client: string
  id_product: string
  id_tenant: string
  typeServico: TypeViewProduct
  modalAction: () => Promise<void>
  isProcessing: boolean
}

export default function NovaApuracaoComModal({
  id_client,
  id_product,
  id_tenant,
  typeServico,
  modalAction,
  isProcessing
}: Props) {
  const { mutate: createApuracao } = useNewApuracao()

  const confirmAction = () => {
    createApuracao(
      {
        update: { id_client, id_product, id_tenant, typeServico }
      },
      {
        onSuccess: () => {
          toast({ description: 'Nova apuração criada com sucesso!' })
          modalAction()
        },
        onError: (error: { message: string }) => {
          toast({ variant: 'destructive', description: 'Erro ao criar nova apuração: ' + error.message })
        }
      }
    )
  }

  return (
    <>
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
        {/* Botão de confirmação para criar nova apuração */}
        <ButtonConfirmAction
          confirmText="Tem certeza de que deseja criar uma nova apuração?"
          successBtnText="Criar"
          cancelBtnText="Cancelar"
          openBtnText={
            isProcessing ? (
              'Processando...'
            ) : (
              <>
                <Sparkles className="h-4 w-4 mr-2 animate-pulse inline-block" />
                Nova Apuração
              </>
            )
          }
          isDisabled={isProcessing}
          onSuccess={confirmAction}
          triggerButtonProps={{
            className:
              'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-medium px-6 py-2.5 rounded-lg shadow-sm transition-all duration-200 hover:shadow-md hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed',
            size: 'default'
          }}
        />
      </div>
    </>
  )
}
